import PageTemplates from "../components/pages/Templates";

const TemplatesRoute = () => {
    return <PageTemplates />;
};

export { TemplatesRoute };
